import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { SettingsProvider } from '@services/settings/settings';

@Injectable()
@Pipe({
	name: 'snDatePickerConfig'
})
export class SnDatePickerConfigPipe implements PipeTransform {
	private snDatePickerOptions: IMyDpOptions;

	constructor(private settingsService: SettingsProvider) {}

	transform(date: string): IMyDpOptions {
		this.settingsService.timeFormatSettings.subscribe(data => {
			if (data.weekStartsOn !== null) {
				const dateFormat =
					data.dateFormat === 'DD_MM_YYYY' ? 'dd/mm/yyyy' : 'mm/dd/yyyy';
				const weekStartsOn = data.weekStartsOn.substring(0, 2).toLowerCase();

				this.snDatePickerOptions = {
					dateFormat,
					firstDayOfWeek: weekStartsOn,
					minYear: 2000,
					openSelectorOnInputClick: true,
					openSelectorTopOfInput: date === 'shootproof options',
					alignSelectorRight: date === 'shootproof options',
					selectorHeight: '252px',
					selectorWidth: '252px'
				};
			}
		});

		return this.snDatePickerOptions;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/pipes/sn-date-picker-config/sn-date-picker.config.ts